import React from "react";
import { Link } from "react-router-dom";
import "../styles/CookiePolicy.css";

const CookiePolicy = () => {
  return (
    <div className="legal-page">
      {/* PAGE HEADER */}
      <div className="legal-header">
        <h1>Cookie Policy</h1>
        <p>
          <Link to="/">Home</Link> / <span>Cookie Policy</span>
        </p>
      </div>

      {/* PAGE CONTENT */}
      <div className="legal-content">
        <p>
          This website uses cookies to receive and store certain types of
          information to enhance your experience. This website is operated by
          <strong> SPARSH CARGO PRIVATE LIMITED</strong>.
        </p>

        <h2>What are cookies?</h2>
        <p>
          Cookies are small text files stored on your device when you visit a
          website. They help us remember information related to your visit,
          such as preferences and browsing activity, to improve website
          functionality.
        </p>

        <p>
          Cookies also help us understand how frequently our web pages are
          accessed. For more information, you may refer to publicly available
          resources on HTTP Cookies.
        </p>

        <h2>Why and how we use cookies?</h2>
        <p>
          SPARSH CARGO PRIVATE LIMITED uses cookies to collect information online
          to improve user experience, website performance, and service quality.
        </p>

        <p>
          These cookies may help us:
        </p>

        <ul>
          <li>Understand website traffic and usage patterns</li>
          <li>Improve website functionality and performance</li>
          <li>Deliver relevant services and information</li>
        </ul>

        <p>
          For more information about specific cookies, users can search the
          cookie names online to understand how the collected data is used.
        </p>

        <h2>Disabling Cookies</h2>
        <p>
          You have the option to accept or disable cookies on your device while
          visiting the website. Your selection is recorded and respected during
          your browsing session.
        </p>

        <h2>More Information</h2>
        <p>
          We hope the information provided above answers your questions. If you
          require further assistance, please contact us at{" "}
          <a href="mailto:support@sparshcargo.com">
            support@sparshcargo.com
          </a>.
        </p>
      </div>
    </div>
  );
};

export default CookiePolicy;
